module.exports = __webpack_public_path__ + "7d1ae955e3eb6d4de49953bc6f16b740.jpg";